import React, { Fragment, useEffect, useRef, useState } from "react";
import BuscarComponent from "./component/BuscarComponent";
import ResultadoComponent from "./component/ResultadoComponent";
import ResumenCompromisoComponent from "./component/ResumenCompromisoComponent";
import TablaComponent from "./component/TablaComponent";
import { filtro, getElectores } from "../../Api/ApiMetodo";
import PaginadorComponent from "./component/PaginadorComponent";
import useAutoRefresco from "../../hooks/useAutoRefresco";
import useCatalogos from "../../hooks/useCatalogos";
import SelectComponent from "../../components/SelectComponent";
import { filtrarPorCompromiso } from "../../constants/compromiso";
const SIN_ELECTOR_INDIVIDUAL = [];

const TablaPages = () => {
  const { opcionesLugar, opcionesMesaDe } = useCatalogos({ incluirCandidatos: false });
  const [electores, setElectores] = useState([]);
  const [selectedOptionlugar, setSelectedOptionlugar] = useState(null);
  const [selectedOptionmesa, setSelectedOptionmesa] = useState(null);
  const [selectedOptionlider, setSelectedOptionlider] = useState(null); //No me esta funcionando cuando hago el filtro en la tabla no se esta mostrando el resulado filtrado, en los dos filtro si esta funcionando pero en este no funciona
  const [busqueda, setBusqueda] = useState("");
  // estado del compromiso a mostrar (null: todos); se filtra sobre la lista ya
  // consultada para que los totales del resumen no cambien al filtrar
  const [filtroCompromiso, setFiltroCompromiso] = useState(null);
  const ultimaConsulta = useRef(0);
  const [currentPage, setCurrentPage] = useState(0);
  const perPage = 20;
  const [lideres, setLideres] = useState([]);

  const cargarLideres = async () => {
    try {
      const response = await getElectores();
      const electoresData = response?.data?.electores || [];
      const nombresLider = electoresData.map((elector) => elector.lider).filter(Boolean);
      // eliminar duplicados
      const lideresUnicos = [...new Set(nombresLider)];
      setLideres(lideresUnicos);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    cargarLideres();
  }, []);

  //metodo de filtro: búsqueda (cédula o nombre, parcial) + líder, lugar y mesa
  const filtrodata = () => {
    // si se escribe rápido, solo se aplica la respuesta de la última consulta
    const consulta = ++ultimaConsulta.current;
    filtro({
      busqueda,
      lider: selectedOptionlider,
      lugar: selectedOptionlugar,
      mesa: selectedOptionmesa,
    })
      .then((response) => {
        if (consulta !== ultimaConsulta.current) return;
        setElectores(response?.electores || []);
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    filtrodata();
  }, [busqueda, selectedOptionlider, selectedOptionlugar, selectedOptionmesa]);

  // al cambiar la búsqueda o un filtro se vuelve a la primera página
  useEffect(() => {
    setCurrentPage(0);
  }, [busqueda, selectedOptionlider, selectedOptionlugar, selectedOptionmesa, filtroCompromiso]);

  // Después de editar o eliminar, y automáticamente cada 30 s: vuelve a
  // consultar respetando la búsqueda y los filtros activos
  const recargarConsulta = () => {
    filtrodata();
    cargarLideres();
  };

  useAutoRefresco(recargarConsulta);

  const electoresVisibles = filtrarPorCompromiso(electores, filtroCompromiso);
  const pageCount = Math.ceil(electoresVisibles.length / perPage);
  const offset = currentPage * perPage;
  const datosOptimizados = electoresVisibles.slice(offset, offset + perPage);

  // mensaje cuando la búsqueda o el filtro de compromiso no dejan electores
  const obtenerMensajeSinResultados = () => {
    if (busqueda && electores.length === 0) {
      return (
        <>
          No se encontraron electores para "<strong>{busqueda}</strong>"
        </>
      );
    }
    if (filtroCompromiso && electoresVisibles.length === 0) {
      return "No hay electores con compromisos en este estado.";
    }
    return null;
  };
  const mensajeSinResultados = obtenerMensajeSinResultados();

  return (
    <Fragment>
      <section>
        <div className="container py-3">
          <BuscarComponent onBuscar={setBusqueda} />
        </div>
      </section>

      <section>
        <div className="container pb-3">
          <div className="row gy-3">
            <div className="col-12 col-sm-6 col-lg-4 col-xl-4">
              <SelectComponent
                id="lider"
                etiqueta="Líderes"
                opciones={lideres.map((lider) => ({ value: lider, label: lider }))}
                valor={selectedOptionlider}
                onCambiar={setSelectedOptionlider}
                placeholder="Seleccionar líder"
              />
            </div>

            <div className="col-12 col-sm-6 col-lg-4  col-xl-4">
              <SelectComponent
                id="lugar"
                etiqueta="Lugar de votación"
                opciones={opcionesLugar}
                valor={selectedOptionlugar}
                onCambiar={(valor) => {
                  // las mesas dependen del lugar: al cambiarlo se quita el filtro de mesa
                  setSelectedOptionlugar(valor);
                  setSelectedOptionmesa(null);
                }}
                placeholder="Seleccionar lugar"
              />
            </div>

            <div className="col-12 col-sm-6 col-lg-4  col-xl-4">
              <SelectComponent
                id="mesa"
                etiqueta="Mesa de votación"
                opciones={opcionesMesaDe(selectedOptionlugar)}
                valor={selectedOptionmesa}
                onCambiar={setSelectedOptionmesa}
                placeholder="Seleccionar mesa"
              />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container mt-3">
          {/* sufragantes a la izquierda; cumplidos / por cumplir al final de la fila */}
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
            <ResultadoComponent cantidad={electoresVisibles.length} />
            <ResumenCompromisoComponent
              electores={electores}
              filtroActivo={filtroCompromiso}
              onFiltrar={setFiltroCompromiso}
            />
          </div>
        </div>
      </section>

      <section>
        <div className="container mt-3">
          {mensajeSinResultados ? (
            <p className="text-center text-muted py-4 mb-0">{mensajeSinResultados}</p>
          ) : (
            // elector=[]: la tabla siempre muestra la lista (la búsqueda ya filtra)
            <TablaComponent
              datos={datosOptimizados}
              elector={SIN_ELECTOR_INDIVIDUAL}
              inicio={offset}
              onCambio={recargarConsulta}
            />
          )}
        </div>
      </section>

      <section>
        <div className="container">
          {pageCount > 0 ? (
            <PaginadorComponent
              pageCount={pageCount}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              total={electoresVisibles.length}
              porPagina={perPage}
            />
          ) : null}
        </div>
      </section>
    </Fragment>
  );
};
export default TablaPages;
